/* 🤖 this file was generated by svg-to-ts */
export const matIconFlightTakeoff: {
  name: 'flight-takeoff';
  data: string;
} = {
  name: 'flight-takeoff',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2.5 19h19v2h-19v-2zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 2.59 4.49L21 11.49c.81-.23 1.28-1.05 1.07-1.85z"/></svg>`
};
